'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var newRelicAvailabile = function newRelicAvailabile() {
  return Boolean(window.newrelic);
};

var MARK_USER_INFO_START = exports.MARK_USER_INFO_START = 'mark_user_info_start';
var MARK_USER_INFO_SUCCESS = exports.MARK_USER_INFO_SUCCESS = 'mark_user_info_success';
var MEASURE_USER_INFO_TIME = exports.MEASURE_USER_INFO_TIME = 'measure_user_info_time';
var MEASURE_API_VERIFY_TIME = exports.MEASURE_API_VERIFY_TIME = 'measure_api_verify_time';

var setCustomAttribute = exports.setCustomAttribute = function setCustomAttribute(name, value) {
  if (newRelicAvailabile()) {
    window.newrelic.setCustomAttribute(name, value);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.196/js/helpers/newRelicReporting.js
// module id = 51
// module chunks = 0